import {
    ProductAvailabilityStatus
} from '~/types';


export function useProductAvailabilityStatus(
    status: Nullable<ProductAvailabilityStatus>
) {

    const statusText = computed<Nilish<string>>(() => {
        switch (status) {
            case ProductAvailabilityStatus.Preorder:
                return 'Preorder';
            case ProductAvailabilityStatus.ComingSoon:
                return 'Coming Soon';
            case ProductAvailabilityStatus.ShipsSoon:
                return 'Ships Soon';
            case ProductAvailabilityStatus.Backorder:
                return 'Backorder';
            case ProductAvailabilityStatus.SoldOut:
                return 'Sold Out';
            case ProductAvailabilityStatus.Discontinued:
                return 'Discontinued'
        }

        return null;
    });

    const canShowEstAvailableDate = computed<boolean>(() => {
        switch (status) {
            case ProductAvailabilityStatus.Preorder:
            case ProductAvailabilityStatus.ComingSoon:
            case ProductAvailabilityStatus.ShipsSoon:
            case ProductAvailabilityStatus.Backorder:
                return true;
        }

        return false;
    });

    return {
        statusText,
        canShowEstAvailableDate
    };
}
